import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Button, Card, CardContent, Typography } from '@mui/material';
import { LockOutlined as LockIcon } from '@mui/icons-material';
import { MODULE_LABELS, getDefaultRoute } from '../constants/rbac';
import { useAdmin } from '../context/AdminContext';

const AccessDenied = ({ module }) => {
  const navigate = useNavigate();
  const { user } = useAdmin();
  const fallbackRoute = getDefaultRoute(user);
  const moduleLabel = module ? MODULE_LABELS[module] || module : null;

  return (
    <Box
      sx={{
        minHeight: 'calc(100vh - 120px)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <Card
        sx={{
          maxWidth: 520,
          width: '100%',
          boxShadow: '0 16px 40px rgba(0, 0, 0, 0.08)',
          borderRadius: 3,
        }}
      >
        <CardContent sx={{ p: 4, textAlign: 'center' }}>
          <LockIcon sx={{ fontSize: 52, color: '#DD2424', mb: 2 }} />
          <Typography variant="h5" sx={{ fontWeight: 700, mb: 1 }}>
            Access Denied
          </Typography>
          <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
            {moduleLabel
              ? `You do not have permission to open ${moduleLabel}.`
              : 'No dashboard modules are currently assigned to this account.'}
          </Typography>

          {fallbackRoute && (
            <Button variant="contained" onClick={() => navigate(fallbackRoute)}>
              Go to Available Module
            </Button>
          )}
        </CardContent>
      </Card>
    </Box>
  );
};

export default AccessDenied;
